/** api */
import useOverlay from "@/hooks/common/useOverlay";
import Alert from "@COMPONENTS/common/modal/alert/Desktop";
import ReportPopup from "@COMPONENTS/product/common/popup/desktop/ReportPopup";
import * as style from "@COMPONENTS/style/detailpackage/reviewpopup";
import {PopupCloseButton} from "@FRAMEWORK/ui/desktop/button";
import {EditorBox} from "@FRAMEWORK/ui/desktop/editor";
import useCustomerMe from "@QUERIES/account/useCustomerMe";
import {EpisodeType} from "@QUERIES/prdt/review/useReviewEpisode";
import dayjs from "dayjs";
import {useCallback, useState} from "react";

interface ReviewPopupProps {
	travrvNo: string;
	episodeList: EpisodeType[];
	close: () => void;
}

const EpisodePopup = (props: ReviewPopupProps) => {
	const [open] = useOverlay();
	const {travrvNo, episodeList, close} = props;

	const [cuurentNo, setCuurentNo] = useState(travrvNo);
	const episode = episodeList.find(v => v.travrvNo === cuurentNo) || null;

	/** 이전 | 다음 travrvNo 데이터 추출 */
	const getTargetNo = useCallback(
		(divi: "next" | "prev") => {
			const direction = divi === "next" ? 1 : -1;
			const currentIndex = episodeList.findIndex(v => v.travrvNo === cuurentNo);
			return episodeList[currentIndex + direction]?.travrvNo || null;
		},
		[cuurentNo],
	);

	const signin = useCustomerMe();
	const isSignin = signin.data?.body.nonUser === false;
	const openReport = () => {
		if (episode?.reportYn === "Y") {
			open(prop => <Alert {...prop} text="신고사유 검토중인 게시물입니다.<br/>빠른 시일 내에 처리하겠습니다." />);
			return;
		}
		if (isSignin) {
			open(overlay => <ReportPopup {...overlay} reportId={travrvNo} reportType="EPISODE" />);
		} else {
			open(prop => (
				<Alert
					{...prop}
					alertType="confirm"
					text="로그인 후 이용하실 수 있습니다. <br/>로그인하시겠습니까?"
					afterConfirm={() => LoginUtil.login()}
				/>
			));
		}
	};

	return (
		<>
			{episode && (
				<style.Wrap>
					<style.Popup>
						<style.Header>
							<h3>여행후기</h3>
							<PopupCloseButton onClose={close} />
						</style.Header>
						<style.Content>
							<style.PostMeta>
								<h4>
									{episode.bestYn === "Y" && <style.BestTag>베스트</style.BestTag>}
									{episode.title}
								</h4>
								<div>
									<style.User>{episode.custNm ?? "- "}님</style.User>
									<style.Date>{dayjs(episode.regDt).format("YYYY.MM.DD")}</style.Date>
								</div>
							</style.PostMeta>
							<style.EditorWrap>
								<EditorBox dangerouslySetInnerHTML={{__html: episode.contents.replace(/\n/g, "<br />")}} />
							</style.EditorWrap>
							<style.ReportWrap>
								<style.ReportBtn onClick={openReport}>신고하기</style.ReportBtn>
							</style.ReportWrap>
						</style.Content>
						{getTargetNo("prev") && (
							<style.SlideButton direction="prev" onClick={() => setCuurentNo(getTargetNo("prev"))}>
								<span>이전 여행후기 보기</span>
							</style.SlideButton>
						)}
						{getTargetNo("next") && (
							<style.SlideButton direction="next" onClick={() => setCuurentNo(getTargetNo("next"))}>
								<span>다음 여행후기 보기</span>
							</style.SlideButton>
						)}
					</style.Popup>
				</style.Wrap>
			)}
		</>
	);
};

export default EpisodePopup;
